<template>
  <HubContainer id="branchCustomersHub">

    <template v-if="atLeastBranchAdmin">
      <HubSection large icon="icon/hub/online-customers.svg"
                  :title="moduleActivated.dispatch ? $t('customers.online') : $t('customers.title')"
                  :description="$t('customers.online_description')"
                  :buttonAction="goToCustomers">
      </HubSection>

      <HubSection large icon="icon/hub/dispatch-customers.svg" v-if="moduleActivated.dispatch"
                  :title="$t('customers.dispatch')"
                  :description="$t('customers.dispatch_description')"
                  :buttonAction="goToDispatchCustomers">
      </HubSection>

      <HubSection large icon="icon/hub/customer-reports.svg"
                  :title="$t('advanced_navigation.customer_report')"
                  :description="$t('advanced_navigation.customer_report_description')"
                  :buttonAction="goToCustomersReport">
      </HubSection>
    </template>
  </HubContainer>
</template>

<script>
  import HubSection from "@/components/HubSection";
  import HubContainer from "@/components/HubContainer";

  export default {
    name: "branchCustomersHub",

    components: { HubSection, HubContainer },

    async mounted() {
      this.$store.state.pageTitleTranslationKey = "customers.title";
      this.$store.state.pageIcon = "icon/nav/users.svg";

      if (this.$route.query.branch) {
        let branchModule = await this.$store.getters.getContextBranchActivatedModule;
        Object.assign(this.moduleActivated, branchModule);
      }
    },

    data() {
      return {
        moduleActivated: {
          onlineOrdering: false,
          kiosk: false,
          mobileApp: false,
          menuBoard: false,
          loyalty: false,
          thirdPartyLoyalty: false,
          aimsVouchers: false,
          onSiteOrdering: false,
          payAtTheTable: false,
          catering: false,
          dispatch: false,
          POS: false,
        }
      }
    },

    computed: {
      atLeastBranchAdmin() {
        return this.$store.getters.loggedUserHasBranchAdmin;
      }
    },

    methods: {
      goToCustomers() {
        this.$router.push(this.$router.buildContext("/customers"));
      },
      goToDispatchCustomers() {
        this.$router.push(this.$router.buildContext("/dispatch-customers"));
      },
      goToCustomersReport() {
        this.$router.push(this.$router.buildContext("/report/customer"));
      },
    }
  }
</script>